module.exports = __webpack_public_path__ + "static/media/yellowBalloon.69fb7029.svg";